import { PriceRanges } from "@/data";
import { formatCurrency } from "@/lib/currency/currency";
import { FBT } from "@/lib/i18n/i18n_provider";
import { useIsWework } from "@/offering/hooks/use_is_wework";

export function useFromPriceLabel(
  priceRanges: PriceRanges | undefined,
  hourlyPrice: number | undefined,
  currency: string | null,
  localeLanguageTag: string,
  fbt: FBT
) {
  const isWeWork = useIsWework();

  const hasPriceRange =
    !!priceRanges &&
    priceRanges.hourly?.lowestPrice !== priceRanges.hourly?.highestPrice;
  let hourlyPriceLabel: string | undefined;
  if (priceRanges?.hourly && hasPriceRange) {
    hourlyPriceLabel = `${fbt("From")} ${formatCurrency(
      priceRanges.hourly.lowestPrice,
      currency,
      localeLanguageTag
    )}${isWeWork ? ` ${fbt("before VAT per hour")}` : fbt("/hour")}`;
  } else if (hourlyPrice) {
    hourlyPriceLabel = `${formatCurrency(
      hourlyPrice,
      currency,
      localeLanguageTag
    )}${isWeWork ? ` ${fbt("before VAT per hour")}` : fbt("/hour")}`;
  }

  const hasDailyPriceRange =
    !!priceRanges &&
    priceRanges.daily?.lowestPrice !== priceRanges.daily?.highestPrice;
  let dailyPriceLabel: string | undefined;
  if (priceRanges?.daily && hasDailyPriceRange) {
    dailyPriceLabel = `${fbt("From")} ${formatCurrency(
      priceRanges.daily.lowestPrice,
      currency,
      localeLanguageTag
    )}${isWeWork ? ` ${fbt("before VAT per day")}` : fbt("/day")}`;
  } else if (priceRanges?.daily?.lowestPrice) {
    dailyPriceLabel = `${formatCurrency(
      priceRanges.daily?.lowestPrice,
      currency,
      localeLanguageTag
    )}${isWeWork ? ` ${fbt("before VAT per day")}` : fbt("/day")}`;
  }

  return { hourlyPriceLabel, dailyPriceLabel };
}
